export default __webpack_public_path__ + "static/media/default-colorful-bg.d4a4f223.png";